import { Footer } from "./Home/Footer";
import { Headermypr } from "./Headermypr";
import { Projectpage } from "./Project_page";

export const Projectpage1 = () => {
  return (
    <>
      <Headermypr />
      <Projectpage />
      <Footer></Footer>
    </>
  );
};
